export ptBR from './pt-BR'
export en from './en'
export es from './es'



// WEBPACK FOOTER //
// ./src/locales/index.js